import React from 'react'
import ListRoles from '../../../components/organisms/admin/roles/ListRoles'

type Props = {}

const ListRolesPage = (props: Props) => {
  return (
    <ListRoles />
  )
}

export default ListRolesPage